import { Icon16Cancel } from '@vkontakte/icons';
// tempexp_20855-next-line
import { ReactComponent as PhotoSwipeIcon } from 'img/icons/photo-swipe.svg';
import React from 'react';
import { useSelector } from 'react-redux';
import { isFeatureAiLetterPromo } from 'reactApp/appHelpers/featuresHelpers/features/aiLetterStylePromo';
import { businessTariffsPromoQuota } from 'reactApp/appHelpers/featuresHelpers/features/businessTariffsPromoQuota';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { getMultiTariffMobileActiveTab } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
// tempexp_20855-next-line
import { useDisableAdsBasicTariff } from 'reactApp/sections/QuotaLanding/hooks/useDisableAdsBasicTariff';
import {
    aiLetterSetItem,
    aiLetterSummaryItem,
    cancelSendItem,
    duplicatesItem,
    familyAlbumsItem,
    familyItem,
    getUploadItem,
    noadsItem,
    notificationItem,
    othersItem,
    prettyAddressItem,
    unlimitedAutouploadItem,
} from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/Features/Features.data';
import type { FeatureItem } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/Features/Features.types';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

const withDisable = (item: FeatureItem, condition: boolean): FeatureItem => {
    return condition
        ? {
              ...item,
              type: 'disabled',
              iconBefore: <Icon16Cancel />,
          }
        : item;
};

export const useFeaturesList = (space: number): FeatureItem[] => {
    const activeTariffTab = useSelector(getMultiTariffMobileActiveTab);
    const uploadLimit = useSelector(ProductsSelectors.getElasticUploadLimitDefault);
    const uploadItem = getUploadItem(uploadLimit);

    const disableConditionBySpace = space < SPACE_LIST.gb_256;

    const secondItem = isFeatureAiLetterPromo ? aiLetterSetItem : duplicatesItem;

    // tempexp_20855-start
    // Эксперимент CLOUDWEB-20855: меняем пункт «Без рекламы…» только у Основного тарифа.
    const disableAdsBasicTariff = useDisableAdsBasicTariff();
    const getAdvancedNoadsItem = (): FeatureItem => {
        if (disableAdsBasicTariff === 'b') {
            return { ...noadsItem, text: 'Без рекламы в Облаке' };
        }
        if (disableAdsBasicTariff === 'c') {
            return { ...noadsItem, text: 'Разбор фото свайпами', iconBefore: <PhotoSwipeIcon /> };
        }
        return noadsItem;
    };

    const advancedNoadsItem = getAdvancedNoadsItem();
    // tempexp_20855-end

    // Собираем фичи в зависимости от таба и определяем значения если нужно
    if (activeTariffTab === ETabsName.basic) {
        return [
            withDisable(unlimitedAutouploadItem, disableConditionBySpace),
            withDisable(secondItem, true),
            withDisable(noadsItem, true),
            withDisable(familyItem, true),
            withDisable(uploadItem, true),
            withDisable(othersItem, true),
        ];
    }

    if (activeTariffTab === ETabsName.advanced) {
        return [
            withDisable(unlimitedAutouploadItem, disableConditionBySpace),
            withDisable(secondItem, disableConditionBySpace),
            // tempexp_20855-next-line
            advancedNoadsItem,
            uploadItem,
            othersItem,
        ];
    }

    if (activeTariffTab === ETabsName.family) {
        return [
            unlimitedAutouploadItem,
            {
                ...familyItem,
                type: 'highlighted',
            },
            familyAlbumsItem,
            noadsItem,
            withDisable(duplicatesItem, disableConditionBySpace),
            othersItem,
        ];
    }

    if (activeTariffTab === ETabsName.for_work) {
        return [
            aiLetterSummaryItem,
            noadsItem,
            notificationItem,
            businessTariffsPromoQuota.showCancelLetterFeature ? cancelSendItem : prettyAddressItem,
            othersItem,
        ];
    }

    return [];
};
